module.exports = __webpack_public_path__ + "static/media/shitw.9740aaa6.jpg";